import { createSelector } from 'reselect'
import playerDataSelector from '../app/playerDataSelector'
import viewSelector from '../app/viewSelector'
import viewTypes from '../../../helpers/enums/views'
import shuffleArray from '../../../helpers/arrayShuffler'
import settingsEnums from '../../../helpers/enums/settings'
import settingsHelper from '../../../helpers/utils/settings'
import { IStore } from '../../reducers/index'

const activitiesSelector = (state: IStore) => state.game.activities

const settingsSelector = (state: IStore) => state.game.settings

export default createSelector(
	viewSelector,
	activitiesSelector,
	playerDataSelector,
	settingsSelector,
	(viewData, activities, playerData, settings) => {
		// TODO: find a better way to return the last activity instead of creating an empty object
		// This is used for applying a placeholder during views transition and the values in the else case are not used
		// because of the RendererFilter
		let activity, activityIndex, activityData
		if (viewData.view === viewTypes.GAME || viewData.view === viewTypes.TEACHER_GAME) {
			activityIndex = activities.findIndex(
				(activity: any) => activity.uid === playerData.view.payload.currentActivityUid
			)
			activityData = activities[activityIndex]

			const answersMode = settingsHelper.getSettingValue(settings, settingsEnums.SETTING_TYPE_ANSWERS_MODE)

			const answersModeRandomize = settingsEnums.SETTING_ANSWERS_MODE_RANDOMIZE

			activity = {
				index: activityIndex,
				...activityData,
				payload: {
					...activityData.payload,
					answers:
						answersMode === answersModeRandomize
							? shuffleArray(playerData.uid + activityIndex, [...activityData.payload.answers])
							: activityData.payload.answers,
					isRandomized: answersMode === answersModeRandomize,
				},
			}
		} else {
			activity = {
				index: 0,
				payload: {},
			}
		}
		// TODO: This index calculation should be changed to the amount of complete activities the player has
		return activity
	}
)
